import { BandClock } from "./band-clock";
import { ConnectionLight } from "./connection-light";
import { Wordmark } from "./wordmark";

/**
 * The board band before we know who is asking: the wordmark, the clock and
 * the connection light — nothing that needs a session.
 * Used while the session check runs and when the server cannot be reached,
 * so the operator always sees the app and the state of the line, never a
 * blank page. Same blue and ribbon as the sidebar's header.
 */
export function BareBand() {
	return (
		<header className="sticky top-0 z-30 bg-board text-white">
			<div className="flex min-h-[3.5rem] flex-wrap items-center gap-x-[0.75rem] gap-y-[0.25rem] px-[1rem] py-[0.375rem] lg:px-[1.5rem]">
				<span className="flex min-h-touch min-w-0 items-center pr-[0.5rem]">
					<Wordmark />
				</span>
				<div className="ml-auto flex items-center gap-[0.25rem] sm:gap-[0.75rem]">
					<BandClock />
					<ConnectionLight />
				</div>
			</div>
			<div aria-hidden="true" className="ovr-ribbon" />
		</header>
	);
}
